// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"registerForm_formWrapper__fUPPM","loginOptions":"registerForm_loginOptions__piYHA"};